const locale = require('./addDocumentActionModal.i18n.json');

/*@ngInject*/
const AddDocumentActionModalController = function ($rootScope, $scope, attachments, collaborationMediator, modalUtil, coreConstant) {

    $scope.i18n = locale;

    $scope.viewModel = {
        availableAttachments: attachments,
        title: _.get($scope.i18n, 'title'),
        cancelButton: _.get($scope.i18n, 'cancel'),
        okButton: _.get($scope.i18n, 'addDocument'),
        selectedAttachment: null,
        placeholderText: _.get($scope.i18n, 'placeholder')
    };

    $scope.canEnableConfirmButton = function () {
        return $scope.viewModel.selectedAttachment;
    };

    $scope.showAddNewAttachmentModal = function () {
        modalUtil.showNewAttachmentModal().then(function (data) {
            $scope.$close(data);
        });
    };

    $scope.onConfirm = function () {
        $scope.$close($scope.viewModel.selectedAttachment);
    };

    $scope.onCancel = function () {
        $scope.$dismiss();
    };

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('gw-um-submission')
    .controller('addDocumentActionModalController', AddDocumentActionModalController);
